/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Journey_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading journey…" |
*
* @param {Journey_LoadingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const journey_loading = /** @type {((inputs?: Journey_LoadingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Journey_LoadingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Traject laden…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement du parcours…")
	return /** @type {LocalizedString} */ ("Loading journey…")
});